import { render, staticRenderFns } from "./desConsulting.vue?vue&type=template&id=1a955272&scoped=true&"
import script from "./desConsulting.vue?vue&type=script&lang=js&"
export * from "./desConsulting.vue?vue&type=script&lang=js&"
import style0 from "./desConsulting.vue?vue&type=style&index=0&id=1a955272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a955272",
  null
  
)

export default component.exports